import { Link, useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ModalContainer from '../../components/modalContainer';

import './style.scss';
import { getBeneficiaries } from '../../API/apiService';
import AddBeneficiaryModal from '../../components/addBeneficiaryModal';
import UserCard from '../../components/userCard';

function UserListGroup() {
  // HOOKS

  const location = useLocation();
  const { groupParam, schoolParam } = useParams();
  const receivedSchool = location.state?.school;
  const receivedGroup = location.state?.group;

  // STATES//
  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [groupName, setGroupName] = useState('');
  const [beneficiaries, setBeneficiaries] = useState('');
  const [info] = useState({
    school: null,
    group: null
  });

  async function loadBeneficiaries(gID) {
    const list = await getBeneficiaries(gID);
    if (list) {
      setBeneficiaries(list);
    }
  }

  useEffect(() => {
    console.log('receivedGroup '+receivedGroup)
    if (receivedGroup) {
      if (receivedGroup?.code.indexOf('Grupo') !== -1) {
        setGroupName(receivedGroup?.code);
      } else {
        setGroupName(`Grupo ${receivedGroup?.code}`);
      }
      if(receivedGroup?.id) {
        info.school = receivedSchool?.id;
        info.group = receivedGroup?.id;
        loadBeneficiaries(receivedGroup.id);
      }
    }
  }, [receivedGroup]);

  useEffect(() => {
    if (groupParam) {
      info.school = schoolParam;
      info.group = groupParam;
      loadBeneficiaries(groupParam);
    }
  }, [groupParam]);

  return (
    <>
      {openModalAdd && (
        <ModalContainer>
          <AddBeneficiaryModal
            info={info}
            setOpenModalAdd={setOpenModalAdd}
            updateData={loadBeneficiaries}
          />
        </ModalContainer>
      )}
      <section className='beneficiaries'>
        <div className='beneficiaries__main group'>
          <div className='group__info info'>
            <div className='info__icon icon'>
              <span className='material-symbols-rounded icon__img'>school</span>
            </div>
            <span className='info__title'>{receivedSchool?.code}</span>
            <span className='info__value'>{groupName}</span>
          </div>
          <Link
            className='group__btn btn'
            to={'/escuelas/grupo/lista_de_encuentros'}
            state={{ group:  info.group  }}>
            <span className='material-symbols-rounded btn__icon'>
              grid_view
            </span>
            <span className='btn__text'>Encuentros</span>
          </Link>
          <button className='group__btn btn'>
            <span className='material-symbols-rounded'>person_add</span>
            <span className='btn__text' onClick={() => setOpenModalAdd(true)}>
              Agregar Beneficiario
            </span>
          </button>
        </div>
        <div className='beneficiaries__students'>
          {beneficiaries.length > 0 &&
            beneficiaries.map((user, index) => (
              <UserCard key={index} user={user} />
            ))}
        </div>
      </section>
    </>
  );
}

export default UserListGroup;